import SvgIcon from '@material-ui/core/SvgIcon';

/** AI sparkle/star icon — used for AI-powered sidebar items and buttons. */
export const AiSparkleIcon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Four-point sparkle star */}
    <path
      d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z"
      fill="currentColor"
      opacity={0.9}
    />
    {/* Small secondary sparkle */}
    <path
      d="M19 15L19.75 17.25L22 18L19.75 18.75L19 21L18.25 18.75L16 18L18.25 17.25L19 15Z"
      fill="currentColor"
      opacity={0.6}
    />
  </SvgIcon>
);
